import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import date from 'date-and-time';

import HeaderEjercicios from '../../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../../Escritorio/Instrucciones';
import BotoneraBottom from '../../../Compartidos/BotoneraBottom';
import useConfigAuth from '../../../../../Hooks/useConfigAuth';

import { finalizarEjercicioAction, setearEjercicioAction, setearUrlAnteriorAction } from '../../../../../actions/estadoEjercicioActions';
import { almacenarAction } from '../../../../../actions/almacenarEjercicioActions';

//css
import { ContainerFlexx, Img, BtnColor, InputTextESC4, FormInput } from '../../../../Css/MetodosCSS/StyledLectoEscritura';
import { AvanzarBtn, AvanzarImg } from '../../../../Css/StyledMatematica';

const instrucciones = 'Escucha la palabra que te dice el niño y escribila.';
const miniInstrucciones = 'Escucha la palabra que te dice el niño y escribila.';

const ESC4 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();

    const [disable, setDisable] = useState(false);
    const [comparar, setComparar] = useState([]);
    const [count, setCount] = useState(1);
    const [palabra, setPalabra] = useState('');
    const [indexes, setIndexes] = useState();
    const [isIncorrect, setIsIncorrect] = useState(false);
    const [isCorrect, setIsCorrect] = useState(false);
    const [contarErrores, setContarErrores] = useState(0);
    const [contarTiempo, setContarTiempo] = useState([]);
    const [ultimoTiempo, setUltimoTiempo] = useState(false);

    const iniciar = useSelector(state => state.ejercicio.iniciar);
    const finalizar = useSelector(state => state.ejercicio.finalizar);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);
    const informacion = useSelector(state => state.informacion.info_DB);
    const lista_usada = useSelector(state => state.informacion.lista_usada);
    const sesion = useSelector((state) => state.ejercicio.sesion);
    const lista = useSelector((state) => state.ejercicio.lista);
    const ayuda_imagen = useSelector((state) => state.configuracion.ayuda_imagen);

    const GoodWork = () => new Audio('/sounds/sonido_bien.mp3').play();
    const TryAgain = () => new Audio('/sounds/sonidoMal.mp3').play();

    const play1 = () => new Audio(`/sounds/${comparar.sonido_url_1}.mp3`).play();

    const verificar = (e) => {
        e.preventDefault();
        if (palabra.toUpperCase() !== comparar.palabra_1.toUpperCase()) {
            console.log('mal');
            setDisable(true);
            setIsIncorrect(true);
            setContarErrores(contarErrores + 1);
            setTimeout(() => {
                setIsIncorrect(false);
            }, 300);
            TryAgain();
            setTimeout(() => {
                setDisable(false);
                setPalabra('');
            }, 1500);
        } else {
            console.log('bien');
            setDisable(true);
            setIsCorrect(true);
            setTimeout(() => {
                setIsCorrect(false);
            }, 300);
            GoodWork();
            if (count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                    setPalabra('');
                }, 1500);
            } else {
                setTimeout(() => {
                    setDisable(false);
                    setUltimoTiempo(true);
                    dispatch(finalizarEjercicioAction());
                }, 1500);
            }
        }
    }

    useEffect(() => {
        dispatch(setearEjercicioAction('ESC4') );
        dispatch(setearUrlAnteriorAction('lecto-escritura/escritura/silaba-directa/'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setComparar(informacion[count-1]);
        setIndexes(Object.keys(informacion).length);
    }, [count, informacion])

    useEffect(() => {
        if(iniciar === false && count === indexes){
            return;
        }else if(iniciar === false && count === 1){
            return;
        } else {
            const newList = JSON.parse(JSON.stringify(contarTiempo));
            newList.push(new Date());
            setContarTiempo(newList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iniciar,count, ultimoTiempo]);

    useEffect(() => {
        if(finalizar){
            const tiempo = JSON.parse(JSON.stringify(contarTiempo));
            const conseguirTiempos = (a) => {
                const t = [];
                for (let i = 0; i < a.length - 1; i++){
                    const despues = new Date(a[i+1]);
                    const antes = new Date(a[i])
                    const segundos = Math.round((date.subtract(despues, antes).toSeconds())*10)/10;
                    t.push(segundos);
                }
                return t
            }
            const tiempoFinal = conseguirTiempos(tiempo);

            const informacion = {
                config,
                payload: {
                    'ejercicio': "ESC4",
                    'errores': contarErrores,
                    'tiempo': tiempoFinal,
                    'id_paciente': id_paciente,
                    'lista_usada': lista_usada,
                    lista,
                    sesion
                }
            }
            dispatch( almacenarAction(informacion) );
            navigate("/escritorio/metodos/finalizar-ejercicio");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);

    return (
        <Fragment>
            <HeaderEjercicios estrellas={true} carrito={true} minMay={false} ayuImagen={true} />
            {iniciar
                ?
                    <ContainerFlexx direction="column" height="100%" width="100%">
                        <ContainerFlexx display="flex" justify="center" align="center" margin="auto">
                            <ContainerFlexx>
                                <Img w="150px" h="200px" src={`/img/nene.png`} />
                            </ContainerFlexx>
                            <ContainerFlexx display="flex" direction="column" justify="center" align="center" >
                                <audio src={`/sounds/${comparar.sonido_url_1}.mp3`} autoPlay />

                                <BtnColor border="none" bg="transparent" 
                                    onClick={() => play1()}
                                >
                                    <Img alt='' w="70px" src={`/img/altavoz.png`} />
                                </BtnColor>
                                {ayuda_imagen ? 
                                    <div>{comparar.ayuda_imagen_1}</div>
                                : null
                                }
                            </ContainerFlexx>

                            <ContainerFlexx width="50vw"
                                isCorrect={isCorrect} isIncorrect={isIncorrect}
                            >
                            <FormInput onSubmit={(e) => verificar(e)}>
                                <InputTextESC4 radius="10px" font="2rem" uppercase="uppercase" type="text" value={palabra} onChange={(e) => setPalabra(e.target.value)} disabled={disable} />
                            </FormInput>
                            </ContainerFlexx>
                        </ContainerFlexx>
                        <ContainerFlexx margin="0 0rem 0 0rem" width="90%" justify="space-between">
                            <BotoneraBottom miniInstrucciones={miniInstrucciones} />
                            <AvanzarBtn
                                disabled={disable}
                                onClick={(e) => verificar(e)}
                            >
                                <AvanzarImg src={'/img/play.png'} /> 
                            </AvanzarBtn>
                        </ContainerFlexx>
                    </ContainerFlexx>
                :
                <Instrucciones instrucciones={instrucciones} />
            }
        </Fragment>
    );
}

export default ESC4;